import React from 'react';
import {useFormik} from 'formik';
import {Loader} from '@components';
import {useSelector, useDispatch} from 'react-redux';
import {toast} from 'react-toastify';
import * as Yup from 'yup';
import {loadUser, logoutUser} from '@store/reducers/auth';
import {updateProfile, uploadImage, getProfile} from '../../services/auth';

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Please enter your name')
    .matches(/^[a-zA-Z\s]+$/, 'Name should only contain letters and spaces')
    .max(25, 'Name should not be greater than 25 characters'),
  mobile: Yup.string()
    .required('Phone number is required')
    .matches(
      /^(\+\d{1,3}[- ]?)?\d{10,14}$/,
      'Phone number must be between 10 and 14 digits'
    ),
  emergencyContact: Yup.string().matches(
    /^(\+\d{1,3}[- ]?)?\d{10,14}$/,
    'Emergency number must be between 10 and 14 digits'
  ),
  address: Yup.string().required('Please enter your address'),
  dob: Yup.date().required('Please select your date of birth')
});

const SettingsTab = ({isActive}: {isActive: boolean}) => {
  const user: any = useSelector((state: any) => state.auth.currentUser);
  const dispatch = useDispatch();
  const [profileImage, setProfileImage] = React.useState('');
  const [showLoader, setShowLoader] = React.useState(false);
  // console.log(user, 'user*********************88');
  // eslint-disable-next-line no-unsafe-optional-chaining
  const {_id: id} = user?.data;
  const initialValues = {
    name: user.data.name,
    email: user.data.email,
    mobile: user.data.mobile,
    gender: user.data.gender,
    dob: user.data.dob,
    emergencyContact: user.data.emergencyContact,
    address: user.data.address,
    userId: id
  };

  const onSubmit = async (values: any) => {
    try {
      console.log(values, '********values55**************');

      let updatedObj = {
        ...values,
        mobile: String(values.mobile),
        emergencyContact: String(values.emergencyContact)
      };

      delete updatedObj.email;
      delete updatedObj.gender;
      delete updatedObj.profileImage;
      delete updatedObj['Emergency Contact Number'];

      updatedObj = {
        ...updatedObj,
        profile: profileImage !== '' ? profileImage : ''
      };

      console.log(updatedObj, '********values67**************');

      setShowLoader(true);

      const res = await updateProfile(updatedObj);
      console.log(res, '*********response while updating user**********');

      if (res?.data?.ok) {
        toast.success('Profile updated successfully');
        const response = await getProfile();
        dispatch(loadUser(response.data));
      } else {
        toast.error(res?.data?.message || 'Failed to update profile');
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      toast.error('Something went wrong. Please try again.');
    } finally {
      setShowLoader(false);
    }
  };

  const uploadUserProfile = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    try {
      const file = event.target.files?.[0];
      if (!file) {
        toast.error('No file selected. Please choose an image.');
        return;
      }

      setShowLoader(true);
      const resp: any = await uploadImage(file);

      if (resp?.status === 200 && resp?.data?.hash) {
        setProfileImage(resp.data.hash);
        toast.success('Image uploaded successfully');
      } else {
        toast.error('Failed to upload image. Please try again.');
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      toast.error('An unexpected error occurred. Please try again.');
    } finally {
      setShowLoader(false);
    }
    // const file = image.target.files[0];
    // setShowLoader(true);
    // if (file) {
    //   const resp = await uploadImage(image.target.files[0]);
    //   setShowLoader(false);

    //   if (resp.status === 200) {
    //     setProfileImage(resp.data.hash);
    //     toast.success('Image uploaded successfully');
    //     return;
    //   }

    //   setShowLoader(false);
    //   toast.error('Something went wrong while uploading the image');
    // }
  };

  const formik: any = useFormik({
    initialValues,
    onSubmit,
    validationSchema
  });

  if (showLoader) {
    return <Loader title="Profile" />;
  }

  return (
    // <div className={`tab-pane ${isActive ? 'active' : ''}`}>
    <form className="form-horizontal" onSubmit={formik.handleSubmit}>
      <div className="row">
        <label htmlFor="inputName" className="col-sm-2 col-form-label">
          Name
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="inputName"
            placeholder="Name"
            name="name"
            onChange={formik.handleChange}
            value={formik.values.name}
          />
          {formik.touched.name && formik.errors.name ? (
            <div className="text-danger mt-1">{formik.errors.name}</div>
          ) : (
            ''
          )}
        </div>
      </div>

      <div className="row">
        <label htmlFor="inputEmail" className="col-sm-2 col-form-label">
          Email
        </label>
        <div className="col-sm-10">
          <input
            type="email"
            className="form-control"
            id="inputEmail"
            name="email"
            disabled
            placeholder="Email"
            value={formik.values.email}
          />
        </div>
      </div>

      <div className="row align-items-center">
        <label htmlFor="inputName2" className="col-sm-2 col-form-label">
          Mobile Number
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="inputName2"
            name="mobile"
            placeholder="Mobile Number"
            onChange={formik.handleChange}
            value={formik.values.mobile}
          />
        </div>
        {formik.touched.mobile && formik.errors.mobile ? (
          <div className="text-danger col-sm-10 offset-sm-2">
            {formik.errors.mobile}{' '}
          </div>
        ) : null}
      </div>

      <div className="row align-items-center">
        <label htmlFor="inputName2" className="col-sm-2 col-form-label">
          Emergency Number
        </label>

        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            id="inputName2"
            placeholder="Emergency Number"
            name="emergencyContact"
            onChange={formik.handleChange}
            value={formik.values.emergencyContact}
          />
        </div>
        {formik.touched.emergencyContact && formik.errors.emergencyContact ? (
          <div className="text-danger col-sm-10 offset-sm-2">
            {formik.errors.emergencyContact}{' '}
          </div>
        ) : null}
      </div>

      <div className="row">
        <label htmlFor="inputSkills1" className="col-sm-2 col-form-label">
          Address
        </label>
        <div className="col-sm-10">
          <textarea
            className="form-control"
            id="inputSkills1"
            placeholder="Address"
            name="address"
            onChange={formik.handleChange}
            value={formik.values.address}
          />
          {formik.touched.address && formik.errors.address ? (
            <div className="text-danger mt-1">{formik.errors.address} </div>
          ) : null}
        </div>
      </div>
      <div className="row">
        <label htmlFor="inputSkills2" className="col-sm-2 col-form-label">
          Date of Birth
        </label>
        <div className="col-sm-10">
          <input
            type="date"
            className="form-control"
            id="inputSkills2"
            placeholder="DOB"
            name="dob"
            onChange={formik.handleChange}
            value={formik.values.dob}
          />
          {formik.touched.dob && formik.errors.dob ? (
            <div className="text-danger mt-1">{formik.errors.dob} </div>
          ) : null}
        </div>
      </div>

      <div className="row">
        <label htmlFor="inputSkills3" className="col-sm-2 col-form-label">
          Profile Image
        </label>
        <div className="col-sm-10 upload-image-input">
          <input
            type="file"
            className="form-control"
            id="inputSkills3"
            name="profile"
            onChange={(e) => uploadUserProfile(e)}
          />
        </div>
      </div>
      <div className="row mt-1">
        <div className="col-sm-10 offset-sm-2">
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};
export default SettingsTab;
